export const SET_ITEMS_PER_PAGE = 'SET_ITEMS_PER_PAGE';
export const SET_SINGLE_PAGE = 'SET_SINGLE_PAGE';
export const SET_MULTIPLE_PAGES = 'SET_MULTIPLE_PAGES';
